import { FormEvent, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { AlertCircle, LoaderCircle } from "lucide-react";
import { useAuth } from "../../app/AuthContext";

export function LoginPage() {
  const { user, login, sessionMessage } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [pending, setPending] = useState(false);

  const from = typeof location.state?.from === "string" && location.state.from.startsWith("/") ? location.state.from : "/";
  if (user) return <Navigate to={from} replace />;

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setPending(true);
    setError("");
    try {
      await login(email, password);
      navigate(from, { replace: true });
    } catch (error) {
      setError(error instanceof Error ? error.message : "Kirjautuminen epäonnistui.");
    } finally {
      setPending(false);
    }
  };

  return (
    <main className="login-page">
      <form className="login-card" onSubmit={submit}>
        <div className="login-brand-row">
          <img className="login-logo login-logo--wide" src="/elmonet-logo-valkoinen.webp" alt="ElmoNet" />
          <img className="login-logo login-logo--allistamo" src="/Allistamo_Logo.png" alt="Ällistämö" />
        </div>
        <span className="kicker">ÄLLISTÄMÖ EXPRESS</span>
        <p className="login-product-copy">ElmoNetin liiketoiminnan työjonot ja automaatiot.</p>
        <h1>Kirjaudu sisään</h1>
        {sessionMessage && <div className="session-ended-notice"><AlertCircle /><span>{sessionMessage}</span></div>}
        <label className="field">
          <span>Sähköposti</span>
          <input type="email" value={email} onChange={(event) => setEmail(event.target.value)} />
        </label>
        <label className="field">
          <span>Salasana</span>
          <input type="password" value={password} onChange={(event) => setPassword(event.target.value)} />
        </label>
        {error && <div className="inline-error">{error}</div>}
        <button className="button button--primary button--wide" disabled={pending || !email || !password}>
          {pending ? (
            <>
              <LoaderCircle className="spin" /> Kirjaudutaan…
            </>
          ) : (
            "Kirjaudu"
          )}
        </button>
      </form>
    </main>
  );
}
